import styled from "styled-components";
import Colors from "../../Constant/Colors";

export const Container = styled.div`
  height: 100%;
  width: 100%;
`;
export const ChartContent = styled.div`
  height: 200px;
  width: 72%;
  min-width:480px ;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
`;
export const EachChart = styled.div`
  height: 170px;
  width: 26%;
  min-width:120px ;
  padding:5px ;
  background-color:${Colors.whiteThemeColor} ;
  border-radius:10px ;
  box-shadow:1px 3px 3px #6666;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left:10px ;
  padding-right:10px ;

`;
